import Component from '@glimmer/component';
import { isEmpty } from '@ember/utils';

/*
  args
    - label
    - textMuted - default true
    - textDanger - default false
      - takes precedence over @textMuted
*/

export default class extends Component {
  get textClass() {
    if (this.args.textDanger) {
      return 'text-danger';
    }
    if (isEmpty(this.args.textMuted) || this.args.textMuted) {
      return 'text-muted';
    }
  }
}
